type AuthModalOptions = {
  reason?: 'manual' | 'protected-route' | 'unauthorized';
};

type AuthModalListener = (options?: AuthModalOptions) => void;

const listeners = new Set<AuthModalListener>();

export const openAuthModal = (options?: AuthModalOptions) => {
  listeners.forEach((listener) => listener(options));
};

export const subscribeAuthModal = (listener: AuthModalListener) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};
